import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Option,
  Modal,
  ModalClose,
  Typography,
  Sheet,
  Box,
} from "@mui/joy";
import toast from "react-hot-toast";
import axiosInstance from "../../api/axios";
import AuthContext from "../../contexts/authContext";

export default function AddCustScheme({
  openAddScheme,
  setOpenAddScheme,
  customerId,
  setCustomerId,
}) {
  const [scheme, setScheme] = useState("");
  const [amount, setAmount] = useState("");
  const [joiningDate, setJoiningDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [totalMonths, setTotalMonths] = useState(11);
  const [endingDate, setEndingDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const { userData, setRefresh } = useContext(AuthContext);

  useEffect(() => {
    if (joiningDate && totalMonths) {
      const joinDate = new Date(joiningDate);
      const endDate = new Date(
        joinDate.setMonth(joinDate.getMonth() + Number(totalMonths))
      );
      const formattedEndDate = endDate.toISOString().split("T")[0];
      setEndingDate(formattedEndDate);
    }
  }, [totalMonths, joiningDate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!scheme || !amount || !joiningDate) {
      toast.error("All fields are required.");
      return;
    }

    try {
      const res = await axiosInstance.post(`/custscheme/add/${customerId}`, {
        schemeId: scheme, // this is the selected scheme _id
        amount: Number(amount),
        joiningDate,
        totalMonths: Number(totalMonths),
        endingDate,
        added_by: localStorage.getItem("userId"),
      });

      if (res.status === 200) {
        toast.success("Scheme added successfully!");
        setScheme("");
        setAmount("");
        setJoiningDate("");
        setCustomerId("");
        setOpenAddScheme(false);
        setRefresh(true);
      }
    } catch (err) {
      toast.error("An error occurred while adding the scheme.");
    }
  };
  const handleCloseAddScheme = () => {
    setScheme("");
    setAmount("");
    setJoiningDate("");
    setCustomerId("");
    setOpenAddScheme(false);
  };
  return (
    <Modal
      open={openAddScheme}
      onClose={handleCloseAddScheme}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Sheet
        variant="outlined"
        sx={{
          maxWidth: 320,
          width: "100%",
          bgcolor: "#FEDDDD",
          p: 4,
          borderRadius: "md",
          boxShadow: "lg",
          m: 2,
        }}
      >
        <ModalClose
          sx={{
            m: 1,
            "& svg": { color: "#800001" },
            "&:hover": {
              backgroundColor: "#800001",
              "& svg": { color: "#fff" },
            },
          }}
          onClick={handleCloseAddScheme}
        />

        <Typography
          level="h4"
          sx={{
            color: "#800001",
            fontWeight: "bold",
            mb: 2,
            textAlign: "center",
          }}
        >
          Add Scheme
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontWeight: "bold",
          }}
        >
          <Typography>
            {userData?.customers?.find((c) => c._id === customerId)?.name}
          </Typography>
          <Typography>
            {userData?.customers?.find((c) => c._id === customerId)?.mobile}
          </Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Scheme</FormLabel>
            <Select
              placeholder="Select scheme"
              value={scheme}
              onChange={(e, newValue) => setScheme(newValue)}
              required
            >
              {userData?.schemes
                ?.filter((s) => s.status !== "erased")
                .map((s) => (
                  <Option key={s._id} value={s._id}>
                    {s.schemeName}
                  </Option>
                ))}
            </Select>
          </FormControl>

          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Amount</FormLabel>
            <Input
              name="amount"
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              required
            />
          </FormControl>

          <Box
            sx={{ display: "flex", gap: 2, justifyContent: "space-between" }}
          >
            <FormControl>
              <FormLabel>Joining Date</FormLabel>
              <Input
                name="joiningDate"
                type="date"
                value={joiningDate}
                defaultValue={new Date().toISOString().split("T")[0]}
                onChange={(e) => setJoiningDate(e.target.value)}
                required
              />
            </FormControl>
            <FormControl sx={{ flex: 1 }}>
              <FormLabel>Duration</FormLabel>
              <Select
                placeholder="Select duration"
                value={totalMonths}
                onChange={(e, newValue) => setTotalMonths(newValue)}
                required
              >
                <Option value={11}>11 Months</Option>
                <Option value={12}>12 Months</Option>
              </Select>
            </FormControl>
          </Box>
          <Typography sx={{ mb: 2, textAlign: "right" }}>
            {" "}
            {endingDate.split("-").reverse().join("-")}{" "}
          </Typography>

          <Button
            type="submit"
            fullWidth
            variant="solid"
            sx={{
              backgroundColor: "#800001",
              color: "white",
              "&:hover": {
                backgroundColor: "#800001",
                color: "#fff",
              },
            }}
          >
            Submit
          </Button>
        </form>
      </Sheet>
    </Modal>
  );
}
